'use client';

import { c as _c } from "react/compiler-runtime";
import { Body, Heading, Label } from '../typography';
import { clsxm } from '../utils';
import { Card } from './Card';
import { FlexContainer } from './FlexContainer';
import InfoTooltip from './InfoTooltip';
import type { ReactNode } from 'react';
export interface StatCardDelta {
  value: number;
  display: string;
}
export type StatCardLayout = 'label-first' | 'value-first';
export interface StatCardProps {
  label: string;
  value: ReactNode;
  delta?: StatCardDelta;
  tooltip?: string;
  className?: string;
  valueSize?: 'md' | 'lg';
  layout?: StatCardLayout;
  chrome?: boolean;
}
function getDeltaColor(delta?: StatCardDelta): string {
  if (!delta || delta.value === 0) return 'text-content-secondary';
  if (delta.value > 0) return 'text-content-positive';
  return 'text-content-negative';
}
export function StatCard(t0) {
  const $ = _c(27);
  const {
    label,
    value,
    delta,
    tooltip,
    className,
    valueSize: t1,
    layout: t2,
    chrome: t3
  } = t0;
  const valueSize = t1 === undefined ? "md" : t1;
  const layout = t2 === undefined ? "label-first" : t2;
  const chrome = t3 === undefined ? true : t3;
  let t4;
  if ($[0] !== label) {
    t4 = <Label className="text-content-secondary" size="sm" weight="medium">{label}</Label>;
    $[0] = label;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== tooltip) {
    t5 = tooltip && <InfoTooltip size="sm" tooltip={tooltip} />;
    $[2] = tooltip;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t4 || $[5] !== t5) {
    t6 = <FlexContainer className="gap-1" items="center">{t4}{t5}</FlexContainer>;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const labelContent = t6;
  let t7;
  if ($[7] !== value || $[8] !== valueSize) {
    t7 = <Heading size={valueSize}>{value}</Heading>;
    $[7] = value;
    $[8] = valueSize;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const valueContent = t7;
  const t8 = !chrome && className;
  let t9;
  if ($[10] !== t8) {
    t9 = clsxm("gap-1", t8);
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== labelContent || $[13] !== layout || $[14] !== valueContent) {
    t10 = layout === "value-first" ? <>{valueContent}{labelContent}</> : <>{labelContent}{valueContent}</>;
    $[12] = labelContent;
    $[13] = layout;
    $[14] = valueContent;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== delta) {
    t11 = delta && <Body className={getDeltaColor(delta)} size="sm">{delta.display}</Body>;
    $[16] = delta;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t11 || $[20] !== t9) {
    t12 = <FlexContainer className={t9} direction="column" items="start">{t10}{t11}</FlexContainer>;
    $[18] = t10;
    $[19] = t11;
    $[20] = t9;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  const content = t12;
  if (!chrome) {
    return content;
  }
  let t13;
  if ($[22] !== className) {
    t13 = clsxm("px-5", className);
    $[22] = className;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== content || $[25] !== t13) {
    t14 = <Card className={t13} padding="md">{content}</Card>;
    $[24] = content;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  return t14;
}